import "./custom.css"
import { animated } from '@react-spring/web'
import styles from "./index.module.css"
import appMovil from "./../../../assets/appMovil.png"
import Carousel from 'react-bootstrap/Carousel'
import { useAnimationElmentoFadeRigth } from '../hooks/useAnimationElmentoFadeRigth'
import { useAnimationElmentoZoomIn } from '../hooks/useAnimationElmentoZoomIn'
import VideoMovil from "../VideoMovil"
import { SITE_DOMAIN } from "../../../config/siteConfig"
const AppReferencia = () => {
    const [refTitulo, propsTitulo] = useAnimationElmentoFadeRigth()
    const [refImagen, propsImagen] = useAnimationElmentoZoomIn()
    const { refCarrucel, propsCarrucel } = useAnimationElmentoZoomIn()
    return (
        <div className={styles.container}>
            <animated.div ref={refTitulo} style={propsTitulo}>
                <h3 className={styles.title}>PORQUE LA APP DE DOODDO ES LA MÁS DESCARGADA ENTRE LOS VIAJEROS</h3>
            </animated.div>
            {/* <animated.div ref={refImagen} style={propsImagen}>
                <img className={styles.iamgen} src={appMovil} alt="App Movil" />
            </animated.div> */}
            <animated.div ref={refCarrucel} style={propsCarrucel}>
                <Carousel controls={false} indicators={true} interval={null} className="customCarrucelLPMOV">
                    <Carousel.Item>
                        <div className={styles.card}>
                            <VideoMovil ruta={`${SITE_DOMAIN}DOODDOVIDEOOFICINA.webm`} />
                            <br />
                            <h6>Te invitamos a conocer nuestras oficinas</h6>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className={styles.card}>
                            <VideoMovil ruta={`${SITE_DOMAIN}APPDOODDO2024.webm`} />
                            <br />
                            <h6>Con la App puedes verificar el status de tu viaje</h6>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className={styles.card}>
                            <VideoMovil ruta={`${SITE_DOMAIN}AGENCIASEGURA.webm`} />
                            <br />
                            <h6>Siempre cuidamos de nuestros viajeros</h6>
                        </div>
                    </Carousel.Item>
                </Carousel>
            </animated.div>
        </div>
    )
}
export default AppReferencia